import { Box } from '@jfs/ui-new'
import React from 'react'
import { ListRenderItem, NativeScrollEvent, NativeSyntheticEvent, StyleProp, ViewStyle } from 'react-native'
import { List } from './List'

const TableComponentMemoed = ({
  ListContent,
  value,
  loadingState,
  scrollEnabled,
  hide,
  onListFooterPress,
  isSeeAllVisible,
  canFetchMore = false,
  isCustom = false,
  RenderCustomElement,
  customOnPress = () => {},
  keyExtractor,
  ItemSeparatorComponent,
  listKey,
  customStyle,
  testID,
  keyboardDismissMode,
  keyboardShouldPersistTaps,
  extraData,
  ListHeaderComponent,
  contentContainerStyle,
  numColumns,
  horizontal,
  flexForListContainer,
  columnWrapperStyle,
  refreshControl,
  ...props
}: {
  loadingState?: boolean
  ListContent: Array<object>
  value: string
  scrollEnabled?: boolean
  hide?: boolean
  onListFooterPress?: () => void
  isSeeAllVisible?: boolean
  canFetchMore?: boolean
  isCustom?: boolean
  RenderCustomElement?: ListRenderItem<any> | null | undefined
  customOnPress?: (item: any) => void
  keyExtractor?: (item: any, index: number) => string
  ItemSeparatorComponent?: React.ComponentType<any> | null
  listKey?: string
  customStyle?: StyleProp<ViewStyle>
  testID?: string
  keyboardDismissMode?: 'none' | 'interactive' | 'on-drag'
  keyboardShouldPersistTaps?: boolean | 'always' | 'never' | 'handled'
  extraData?: any
  ListHeaderComponent?: React.ComponentType<any> | React.ReactElement | null
  contentContainerStyle?: StyleProp<ViewStyle>
  numColumns?: number
  horizontal?: boolean
  flexForListContainer?: number
  columnWrapperStyle?: StyleProp<ViewStyle>
  onScroll?: (event: NativeSyntheticEvent<NativeScrollEvent>) => void
  decelerationRate?: 'fast' | 'normal' | number
  disableIntervalMomentum?: boolean
  pagingEnabled?: boolean
  snapToOffsets?: number[]
  getItemLayout?: (
    data: Array<any> | null | undefined,
    index: number,
  ) => { length: number; offset: number; index: number }
  ref?: any
  onMomentumScrollEnd?: (event: NativeSyntheticEvent<NativeScrollEvent>) => void
  overScrollMode?: 'auto' | 'always' | 'never'
  accessibilityLabel?: string
  onEndReached?: ((info: { distanceFromEnd: number }) => void) | null
  onEndReachedThreshold?: number | null
  stickyHeaderIndices?: number[]
  refreshControl?: any
}) => {
  if (hide) {
    return null
  }

  return (
    <Box flex={flexForListContainer}>
      <List
        disabled={false}
        data={ListContent}
        scrollEnabled={scrollEnabled}
        onPress={customOnPress}
        onListFooterPress={onListFooterPress}
        isSeeAllVisible={isSeeAllVisible}
        canFetchMore={canFetchMore}
        type={value}
        loadingState={loadingState || false}
        isCustom={isCustom}
        RenderCustomElement={RenderCustomElement}
        keyExtractor={keyExtractor}
        ItemSeparatorComponent={ItemSeparatorComponent}
        listKey={listKey}
        customStyle={customStyle && customStyle}
        testID={testID}
        keyboardDismissMode={keyboardDismissMode}
        keyboardShouldPersistTaps={keyboardShouldPersistTaps}
        extraData={extraData}
        ListHeaderComponent={ListHeaderComponent}
        contentContainerStyle={contentContainerStyle}
        numColumns={numColumns}
        horizontal={horizontal}
        columnWrapperStyle={columnWrapperStyle}
        refreshControl={refreshControl}
        {...props}
      />
    </Box>
  )
}
const TableComponent = React.memo(TableComponentMemoed)

export { TableComponent }
